import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import * as globals from '../globals';

@Injectable()
export class AccountAdminService {

  private accountSettingsUrl = globals.APIURL + '/admin/settings';

  constructor(private http: Http, public authHttp: AuthHttp) { }

  getAccountSettings(): Observable<string> {
    let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({ body: '', headers: headers });
      //console.log('Projects: OPTIONS =>', options);
      //console.log('URL:', this.projectsUrl);
      return this.authHttp.get(this.accountSettingsUrl, options)
        .map(this.extractData)
        .catch(this.handleError);
  }

  updateAccountSettings(AccountSettings): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let body = JSON.stringify({date_format_id: AccountSettings.date_format_id, currency_id: AccountSettings.currency_id, quote_auto_sequence_enabled: AccountSettings.quote_auto_sequence_enabled,
      quote_auto_sequence_start: AccountSettings.quote_auto_sequence_start, quote_auto_sequence_padding: AccountSettings.quote_auto_sequence_padding, quote_contact_info: AccountSettings.quote_contact_info, quote_document_footer: AccountSettings.quote_document_footer, });
    let options = new RequestOptions({ body: body, headers: headers });
    //console.log('Projects: OPTIONS =>', options);
    //console.log('URL:', this.projectsUrl);
    return this.authHttp.put(this.accountSettingsUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    //console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/accountadmin/accountadmin.service.ts